export default __webpack_public_path__ + "static/media/Club-Nasha.136c0ddb.png";